import React, { Component, Fragment } from 'react';

import Media from 'react-media';

class Footer extends Component {
    render() {
        return (
            <Fragment>
                <div style={horizontalDivider} />
                <div style={footerWrapperStyle}>
                    <div style={footerStyle}>
                        <div style={footerSubStyle}>

                            <Media queries={{
                                narrow: "(max-width: 599px)",
                                wide: "(min-width: 600px)"
                            }}>
                            {matches => (
                                <Fragment>
                                    {matches.narrow && 
                                    <Fragment>
                                        <h1 style={footerHeaderStyleSmall}><a href="https://scholar.google.com/citations?user=Z5AZ0PgAAAAJ&hl=en&oi=ao" target="_blank">Google Scholar</a> | <a href="https://www.researchgate.net/profile/Ernesto_Calvo" target="_blank">ResearchGate</a> | <a href="https://twitter.com/ecalvo68" target="_blank">Twitter</a> | <a href={require("../files/cv.pdf")} target="_blank">CV</a></h1>
                                    </Fragment>}

                                {matches.wide && 
                                    <Fragment>
                                    <h1 style={footerHeaderStyle}><a href="https://scholar.google.com/citations?user=Z5AZ0PgAAAAJ&hl=en&oi=ao" target="_blank">Google Scholar</a> | <a href="https://www.researchgate.net/profile/Ernesto_Calvo" target="_blank">ResearchGate</a> | <a href="https://twitter.com/ecalvo68" target="_blank">Twitter</a> | <a href={require("../files/cv.pdf")} target="_blank">CV</a></h1></Fragment>}
                                </Fragment>
                            )}
                            </Media>

                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const horizontalDivider = {
    width: '530px',
    height: '2px',
    margin: '10px auto',
    backgroundColor: '#e8e8e8',
}

const footerWrapperStyle = {
    width: '100%',
    padding: '0px 20px 10px 20px',
}

const footerStyle = {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
}

const footerSubStyle = {
    width: '1200px',
    margin: '0px 0px 0px 0px',
    padding: '10px 10px 0px 10px',
    borderRadius: '5px',
    textAlign: 'center',
    order: '3',
}

const footerHeaderStyle = {
    fontFamily: 'Heebo, sans-serif',
    fontSize: '22px',
    fontWeight: '300',
    padding: '10px 20px 0px 19px'
}

const footerHeaderStyleSmall = {
    fontFamily: 'Heebo, sans-serif',
    fontSize: '16px',
    fontWeight: '300',
    padding: '10px 20px 0px 19px'
}

export default Footer;